export default __webpack_public_path__ + "static/media/planning.b1517b80.png";